import React, {Fragment} from 'react';
import Button from "../../Button";
import TextInput from '../../TextInput';
import CheckBox from '../../CheckBox';
import Select from '../../Select';
import Modal from "../../../layout/Modal";
import Portal from "../../../layout/Portal";
import {set, get} from '../../../../utils/dotutils';
import isEqual from "lodash-es/isEqual";
import htmlspecialchars from "locutus/php/strings/htmlspecialchars";
import {optionsTemplate, ProductSelectSmall} from "../../../../utils/formatters";
import {isEmpty} from "../../../../utils/other";
import ComponentConfig from "../../ComponentConfig";

const BlockquoteNode = (props) => <blockquote>{props.children}</blockquote>;

const isBlockquote = (value) => value.blocks.size + "" === "1" && value.blocks.find((block) => block.type + "" === 'blockquote');

const BlockquoteButton = (props) => {
    return <Button
        onClick={(e) => {
            let editor = null;
            let block = isBlockquote(props.value);
            if (block) {
                editor = props.editor.setNodeByKey(block.key, {type: 'paragraph'});
            } else {
                const block = props.value.blocks.find(() => true);
                if (block) {
                    editor = props.editor.setNodeByKey(block.key, {type: 'blockquote'});
                }
            }
            props.saveEditing && props.saveEditing(editor);
            return false;
        }}
        icon="format_quote"
        color={isBlockquote(props.value) ? "primary" : "default"}
        tooltip="Idézet"
        disabled={props.disabled}
    />
};

export {BlockquoteNode, BlockquoteButton};